<template>
  <div class="side-bar">
     <!-- :default-openeds="open_list" -->
     <p class="appName">{{appName}}</p>
    <el-menu
      router
     
      background-color="#009E7D"
      text-color="#FFFFFF"
      active-text-color="#ffffff"
      :default-active="activeIndex"
      style="margin-top: 20px"
    >
      <!-- <template v-for="(menu, index) in subMenuIndex" >
     
          <el-submenu  class="huaHover" :index="menu.url" :route="{ name: menu.url}" :key="index">
            <span slot="title" style="font-size:18px;padding-left:6px !important;" >
              <img :src="`./../assets/${menu.attrs.icon}.png`" v-if="menu.attrs && menu.attrs.icon" alt="" width="20px" height="20px" >
              {{ menu.title}}
            </span>
          </el-submenu>
      </template> -->

      <el-menu-item :index="subMenuIndex[0].url" style="padding:0 30px !important" v-if="subMenuIndex && subMenuIndex[0]">
        <!-- <img src="require("../../static/erf-icon-book.png")" alt=""> -->
        <img :src=" getImgSrc(subMenuIndex[0].attrs.icon)" v-if="subMenuIndex[0].attrs &&subMenuIndex[0].attrs.icon" alt="" width="20px" height="20px" >
             
        <span slot="title" style="font-size:18px;" >{{subMenuIndex[0].title}}</span>
      </el-menu-item>

      <template v-for="(menu, index) in subMenu">
        <el-submenu :index="`${index}`" :key="index" class="huaHover">
          <span
            slot="title"
            style="font-size: 18px; padding-left: 6px !important"
          >
          <!-- <img src="/static/erf-icon-home.png" alt=""> -->
            <img
              :src="getImgSrc(menu.attrs.icon)"
              v-if="menu.attrs && menu.attrs.icon"
              alt=""
              width="20px"
              height="20px"
            />
            {{ menu.title }}
          </span>

          <el-menu-item-group v-if="menu.children != ''">
            <div v-for="(subitem, idx) in menu.children" :key="idx">
              <el-menu-item
                :index="subitem.url"
                :route="{ name: subitem.url }"
                :key="subitem.url"
                style="padding-left:0px !important"
              >
                {{ subitem.title }}
              </el-menu-item>
            </div>
          </el-menu-item-group>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>
<script>
import Commons from "@/config/commons";
import Bus from "@/utils/bus";
import { ApiMessage } from "@/utils/util";
import API from '@/config/api'

export default {
  name: "main-menu",
  data() {
    return {
      // open_list: ["0"],
      currentAppName: "应用名称",
      mainMenuId: Bus.mainMenuId,
      subMenu: [],
      appList: [],
      defaultAppid: null,
      defaultAppName: "",
      activeIndex: "",
      subMenuIndex: [],
      appName:""
    };
  },
  
  watch: {
    mainMenuId: function () {
      this.loadMenu(this.mainMenuId);
    },
  },
  mounted() {
    this.loadMenu(this.mainMenuId);
    var myself = this;
    Bus.$on("menu-update", function (menuId) {
      myself.mainMenuId = menuId;
    });
  },
  created() {
    this.appList = this.$API.APPLIST;
    this.defaultAppName = this.$API.APPNAME;
    this.loadApplist()
  },
  methods: {
     loadApplist() {
      //  debugger
      this.$http
        .post(API.APP_LIST2,  { permissions: ['app_manager'], system: 'erf' })
        .then((resp) => {
          // debugger
          const data = resp.body;
          this.appList = data.apps;
          let appObj= this.appList.find(item=>item.appid==this.$API.APPID)
          this.appName =  appObj.name
          // debugger
     })
        },
    getImgSrc(img) {
      return require(`../../static/${img}.png`)
    },
    changeAppid(name) {
      this.$API.APPID = name;
      for (let i = 0; i < this.appList.length; ++i) {
        if (this.appList[i].appid === this.$API.APPID) {
          this.defaultAppName = this.appList[i].name;
          sessionStorage.setItem("currentApp", JSON.stringify(this.appList[i]));
          break;
        }
      }
      console.log(this.$API.APPID);
      console.log(this.mainMenuId);
      if (this.mainMenuId != undefined) {
        let currentUrl = window.location.href.split("#")[1];
        let toUrl = null;
        var localMenu = sessionStorage.getItem("localMenu");
        if (localMenu && typeof localMenu == "string") {
          var localMenu = JSON.parse(localMenu);
          for (let i = 0; i < localMenu.length; ++i) {
            if (localMenu[i].attrs.mainMenuId === this.mainMenuId) {
              toUrl = localMenu[i].url.substr(2);
              if (toUrl === currentUrl) {
                this.$router.go(0);
              } else {
                this.$router.replace({
                  path: toUrl,
                });
              }
            }
          }
        }
      } else {
        this.$router.go(0);
      }
    },
    loadMenu(menuId) {
      if (!menuId) return;
      var localMenu = sessionStorage.getItem("localMenu");
      if (localMenu && typeof localMenu == "string") {
        var localMenu = JSON.parse(localMenu);
        for (var i in localMenu) {
          if (localMenu[i].attrs && localMenu[i].attrs.mainMenuId == menuId) {
            console.log("load submenu from sessionStorage");
            this.subMenu = localMenu[i].children;
            this.updateActive();
            return;
          }
        }
      }

      this.$http
        .post(this.$API.ROLE_MEUN, {
          mainMenuId: menuId,
          system: "erf",
        })
        .then((resp) => {
          let m = resp.data;
          if (m.rc == 0) {
            this.subMenu = m.menus[0].children.slice(0);
            this.subMenu.shift();
            this.subMenuIndex.push(m.menus[0].children[0]);
            console.log(this.subMenuIndex, "000000000000000000000000000000");
            console.log(this.subMenu, "111111111111111111");
          }
        })
        .catch((error) => {
          Commons.handleApiError(this, error);
        });
    },
    /*
      handleSelect(key, keyPath) {
        if (sessionStorage.getItem("submenuIndex") != null) {
          sessionStorage.removeItem("submenuIndex");
        }
        sessionStorage.setItem("submenuIndex", key);
      },
      */
    updateActive() {
      /*
        let temp = sessionStorage.getItem("submenuIndex")
        if (temp == null) {
          this.activeIndex = '0-0'
        } else {
          this.activeIndex = temp;
        }
        */
      // let url = window.location.href;
      // if (url.indexOf("#") != -1) {
      //   let temp = url.split('#', 2)[1];
      //   console.log(temp)
      //   console.log('temp')
      //   if (temp == '/') {
      //     this.activeIndex = '0-0'
      //   } else if (temp == '/clockin') {
      //     this.activeIndex = '0-1'
      //   } else if (temp == '/homework') {
      //     this.activeIndex = '0-2'
      //   } else if (temp == '/student') {
      //     this.activeIndex = '0-3'
      //   }
      //   console.log(this.activeIndex)
      // } else {
      //   this.activeIndex = '0-0'
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../views/fyd-style.less";
// @import "../commonEdu";
.side-bar {
  min-height: 50vw;
  // background-color: #ffffff;
}
// .huaHover :hover{
//   background: #56d6bb !important;
// }
.huaHover i {
  color: #fff !important;
}
.el-submenu__title i {
  color: #fff !important;
}
.appName{
  font-size: 16px;
    color: #fff;
    margin-left: 30px;
    // margin-top: 20px;
    font-weight:500;
    // background-color: #56D6BB !important;
    // // opacity: 0.5;
    // height: 40px;
}
</style>


// WEBPACK FOOTER //
// Menu.vue?432e23d9